import type { AdgsSweep, AutobuildOutcome } from '@a7y/types';

export function adgsSweepOutcome(sweep: AdgsSweep): AutobuildOutcome {
  if (sweep.status !== 'completed') return 'running';
  if (sweep.conclusion === 'success') return 'success';
  if (sweep.conclusion === 'skipped' || sweep.conclusion === 'cancelled') return 'skipped';
  return 'failure';
}

/**
 * Everything that is not a completed success — failures, skips, and runs still
 * in flight. Derived from `adgsSweepOutcome` rather than re-reading `conclusion`
 * so the table's filter and its Outcome column can never disagree about what a
 * row is. A running sweep is included deliberately: it has not succeeded, and
 * hiding it would make the filter claim a day was clean while a run was open.
 */
export function isUnsuccessfulSweep(sweep: AdgsSweep): boolean {
  return adgsSweepOutcome(sweep) !== 'success';
}
